import React from 'react'
import FavoriteLocation from '../../../../components/Tabs/FavoriteItems/FavoriteLocation';
import { REACT_APP_CLOUD_FRONT } from '../../../../constants';
import { Info } from '../../../../images/svgIcons/svg';

interface IInActiveLocationProps {
  styleClasses: { readonly [key: string]: string }
  location: any;
  isDeviceIos: boolean
  hovered: number
  isGuest: boolean;
  favoriteButtonHandler: any
  favoriteLocations: number[]
  handleSelectedLocation: (LocationModel) => void;
  getInfo:(id) => void
}

const InActiveLocation: React.FC<IInActiveLocationProps> = ({ isGuest, styleClasses, location, isDeviceIos, hovered, favoriteButtonHandler, favoriteLocations,handleSelectedLocation, getInfo }) => {
  const isFavorite = () => {
    return favoriteLocations.includes(location.id);
  }
  const locationDistance = () => {
    if (location?.distance !== null && location?.distance !== undefined && location?.distance > 0) {
        return <React.Fragment>
            <span className={`d-block h-18 font-Visby-cf f-s12 pt-1}`}>{location.distance} miles</span>
        </React.Fragment>
    }
}
  const handleLocationSelect = (location) => {
    if (location.is_live) handleSelectedLocation(location);
  };

  return (
    <React.Fragment>
      <div
        className={`${location.id === hovered && styleClasses.active} ${
          styleClasses.location_card
        } ${!location.is_live && styleClasses.location_in_active} pb-1 pt-0 px-1`}
        data-testid="searched-location-items"
      >
        <li
          className={` d-flex align-items-center justify-content-between `}
          onClick={() => handleLocationSelect(location)}
          data-testid="in-active-locations"
        >
          <div className="d-flex gap-3 align-items-center">
            <div className={styleClasses.location_image}>
              <img
                src={
                  isDeviceIos
                    ? `${REACT_APP_CLOUD_FRONT}/Locations/` +
                      location.id +
                      "/location-" +
                      location.id +
                      ".jpeg" +
                      `?v=${process.env.REACT_APP_LOCATION_IMAGES_VERSION}`
                    : `${REACT_APP_CLOUD_FRONT}/Locations/` +
                      location.id +
                      "/location-" +
                      location.id +
                      ".webp" +
                      `?v=${process.env.REACT_APP_LOCATION_IMAGES_VERSION}`
                }
                alt={location.name}
              />
            </div>
            <div>
              <p
                className={`f-s12 font-Visby-cf h-14 mb-1 f-w6 clr-dark-blue text-uppercase ${styleClasses.location_info}`}
              >
                SELECTED LOCATION
              </p>
              <h4 className={`f-s18 mb-0 h-22 font-Cls text-capilatize`} data-testid="searched-location-name">
                {location.name}
              </h4>
              <span className={`d-block f-s14 f-w5 h-18 font-Visby-cf`} data-testid="searched-location-address">
                {`${location?.address}, ${location?.city}${location?.state ? `, ${location?.state}` : ""}${location?.zip ? `, ${location?.zip}` : ""}`}
              </span>
              <span className={`d-block f-s14 h-18 font-Visby-cf`}>
                {location.city_state_zip}
              </span>
              <span className={`d-block f-s14 f-w5 h-18 font-Visby-cf clr-dark-blue`}>
                {location?.phone}
              </span>
              {location.is_coming ? (
                <h4 className={`d-block f-s14 f-w5 h-18 font-Visby-cf ${styleClasses.coming_soon_label}`} data-testid="searched-location-name">
                  {"COMING SOON!"}
                </h4>
              )
                : null}
            </div>
          </div>

          <div
            className={`${styleClasses.card_info_content} d-flex flex-column justify-content-center align-items-center`}
          >
            <div>
              <FavoriteLocation
                handleFavoriteToggle={(e) =>
                  favoriteButtonHandler(e, location)
                }
                favorite={isFavorite()}
                width={'24'}
              />
            </div>
            <span
              className={`${isGuest && "p-2"} ${location.is_coming && styleClasses.location_is_coming}` }
              onClick={(e) => {
                e.stopPropagation();
                if (location.is_live || location.is_coming) getInfo(location.name);
              }}
            >
              <Info />
            </span>
            {locationDistance()}
          </div>
        </li>
        {!location.is_live && (
          <p className="clr-red-dark f-s14 mb-0 mt-2 text-center">
            This location is currently unavailable.
          </p>
        )}
      </div>

      <hr className={`${styleClasses.border_bottom} pt-0 mt-2`} />
    </React.Fragment>
  );
};

export default InActiveLocation;
